import { render } from "./AppDocumentUpload.vue?vue&type=template&id=93be1cb4&scoped=true"
import script from "./AppDocumentUpload.vue?vue&type=script&lang=js"
export * from "./AppDocumentUpload.vue?vue&type=script&lang=js"

import "./AppDocumentUpload.vue?vue&type=style&index=0&id=93be1cb4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93be1cb4"]])

export default __exports__